import React, { memo, useMemo } from "react";
import { Link } from "react-router-dom";
import "./LandingPage.scss";
import LandingPageCard from "../LandingPageCard/LandingPageCard";

function LandingPage(props) {
  const { loading, appSettings, favouriteApps, unfavouriteApp, apps } = props;
  const backgroundStyle = {};
  if (appSettings && appSettings.dashboardBackground) {
    backgroundStyle.background = 'radial-gradient(circle at left top, rgba(95, 0, 253, 0.18) 0%, transparent 35%), radial-gradient(circle at right top, rgb(255 78 1 / 28%) 0%, transparent 40%), linear-gradient(rgb(245, 245, 245) 0%, rgb(238, 244, 255) 100%)';
  }

  const extraButtons = useMemo(() => {
    return appSettings != null && appSettings.extraButtons != null ? appSettings.extraButtons : [];
  }, [appSettings]);

  const backgroundOverlayStyle = {
    backgroundColor:
      appSettings && appSettings.backgroundImageOverlayColor
        ? appSettings.backgroundImageOverlayColor
        : "transparent",
    opacity:
      appSettings && appSettings.backgroundImageOverlayColorOpacity
        ? appSettings.backgroundImageOverlayColorOpacity
        : 1,
    width: "100%",
    height: "100%",
    flexDirection:
      appSettings && appSettings.backgroundFlexDirection
        ? appSettings.backgroundFlexDirection
        : "column",
    justifyContent:
      appSettings && appSettings.backgroundJustifyContent
        ? appSettings.backgroundJustifyContent
        : "center",
    padding:
      appSettings && appSettings.backgroundPadding
        ? appSettings.backgroundPadding
        : "15vh 20rem 10vh 20rem",
  };

  const extraButtonsContainerStyle =
    appSettings && appSettings.extraButtonsContainerStyle
      ? appSettings.extraButtonsContainerStyle
      : {};
  const showAppIcon = appSettings && appSettings.showAppIcon ? appSettings.showAppIcon : false;

  return (
    <div style={backgroundStyle} className="axiom-home-page">
      <div style={backgroundOverlayStyle} className="axiom-landing-page">
        <div className="axiom-landing-page-content">
          {extraButtons.length >= 0 && (
            <div className="axiom-landing-apps extra-buttons" style={extraButtonsContainerStyle}>
              {extraButtons.map((app) => (
                <LandingPageCard key={app.name} app={app} showAppIcon={true} />
              ))}
            </div>
          )}
          <div className="axiom-landing-page-heading">
            <h1 className="axiom-landing-page-title">{AxiomAPIs.translate("Favourite Apps")}</h1>
            {favouriteApps.length < apps.length && (
              <Link to="/all-apps" className="axiom-landing-page-more">
                {AxiomAPIs.translate("All Apps")}
              </Link>
            )}
          </div>
          <div className="axiom-landing-apps">
            {favouriteApps.map((app) => (
              <LandingPageCard
                key={app.name}
                app={app}
                favouriteAppFunction={unfavouriteApp}
                favApps={true}
                showAppIcon={showAppIcon}
              />
            ))}
            {!loading && favouriteApps.length === 0 && (
              <div className="app-blank-message">
                You don't have any favourite apps. Click on all apps to grab some :)
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(LandingPage);
